import type {TextSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/text-slide-item.class';
import type {ImageSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/image-slide-item.class';
import type {VideoSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/video-slide-item.class';

export const DEFAULT_SLIDE_DURATION = 3;
export const SLIDESHOW_MIN_SCALED_DIMENSION = 30;

export type SlideItem = TextSlideItem | ImageSlideItem | VideoSlideItem;
